import WatsonXConfiguration from './ProviderConfigs/WatsonXConfiguration';
import DefaultConfiguration from './ProviderConfigs/DefaultConfiguration';
import GeminiConfiguration from './ProviderConfigs/GeminiConfiguration';
import CerebrasConfiguration from './ProviderConfigs/CerebrasConfiguration';
import MistralConfiguration from './ProviderConfigs/MistralConfiguration';
import NovitaConfiguration from './ProviderConfigs/NovitaConfiguration';

const cloneDeep = (value) => JSON.parse(JSON.stringify(value));

export const providerParameterDefaults = {
    IBM: {
        decoding_method: 'sample',
        temperature: 0.7,
        min_new_tokens: 10,
        max_new_tokens: 256,
        top_p: 0.9,
        top_k: 50,
        repetition_penalty: 1.0,
        stop_sequence: [],
    },
    Groq: {
        max_tokens: 200,
        n: 1,
        top_p: 1,
        stop: ['<|endoftext|>', '<|endofcode|>'],
        temperature: 0,
        frequency_penalty: 1.2,
        presence_penalty: 0,
        response_format: {
            type: 'text'
        },
    },
    SambaNova: {
        max_tokens: 200,
        top_p: 1,
        top_k: 50,
        stop: ['<|endoftext|>', '<|endofcode|>'],
        temperature: 0,
    },
    OnPrem: {
        temperature: 1.0,
        max_tokens: 200,
        top_p: 1.0,
        stop: null,
        frequency_penalty: 0.0,
        presence_penalty: 0.0,
        seed: null,
    },
    Cerebras: {
        temperature: 1.0,
        max_completion_tokens: 200,
        top_p: 1.0,
        seed: null,
        stop: null,
        stream: false,
    },
    Gemini: {
        temperature: 1.0,
        top_p: 0.95,
        top_k: 40,
        candidate_count: 1,
        max_output_tokens: 200,
        stop_sequences: [],
        presence_penalty: 0.0,
        frequency_penalty: 0.0,
        seed: null,
    },
    Mistral: {
        temperature: 0.7,
        top_p: 0.9,
        frequency_penalty: 0.0,
        presence_penalty: 0.0,
        random_seed: null,
        max_tokens: 200,
        stop: [],
        stream: false,
    },
    Novita: {
        temperature: 1.0,
        top_p: 1.0,
        top_k: 40,
        max_tokens: 512,
        stop: null,
        n: 1,
        presence_penalty: 0.0,
        frequency_penalty: 0.0,
        seed: null,
        stream: false,
    }
};

export const providerParameterFieldMap = {
    IBM: 'watsonParameters',
    Groq: 'groqParameters',
    SambaNova: 'sambaNovaParameters',
    OnPrem: 'onPremParameters',
    Cerebras: 'cerebrasParameters',
    Gemini: 'geminiParameters',
    Mistral: 'mistralParameters',
    Novita: 'novitaParameters'
};

export const buildProviderParametersState = (overrides = {}) => {
    const state = {};

    Object.entries(providerParameterFieldMap).forEach(([provider, field]) => {
        const base = cloneDeep(providerParameterDefaults[provider]);
        state[field] = overrides[field]
            ? {
                ...base,
                ...overrides[field]
            }
            : base;
    });

    return state;
};

export const getProviderParameterField = (providerKey) => providerParameterFieldMap[providerKey] || null;

export const updateProviderParametersState = (providerKey, data, setForm) => {
    const field = getProviderParameterField(providerKey);
    if (!field || typeof setForm !== 'function') return;
    setForm(prev => ({
        ...prev,
        [field]: data
    }));
};

export const setProviderParametersField = (providerKey, data, setForm) => {
    const field = getProviderParameterField(providerKey);
    if (!field || typeof setForm !== 'function') return;
    setForm(field, data);
};

export const providerConfigRegistry = {
    IBM: {
        component: WatsonXConfiguration,
        getProps: ({
            form,
            handleParameter
        }) => ({
            parametersWatsonX: form.watsonParameters,
            setParametersWatsonX: handleParameter,
            selectedModel: form.selectedModel
        })
    },
    Groq: {
        component: DefaultConfiguration,
        getProps: ({
            form,
            handleParameter
        }) => ({
            parameters: form.groqParameters,
            setParameters: handleParameter
        })
    },
    SambaNova: {
        component: DefaultConfiguration,
        getProps: ({
            form,
            handleParameter
        }) => ({
            parameters: form.sambaNovaParameters,
            setParameters: handleParameter
        })
    },
    OnPrem: {
        component: DefaultConfiguration,
        getProps: ({
            form,
            handleParameter
        }) => ({
            parameters: form.onPremParameters,
            setParameters: handleParameter
        })
    },
    Gemini: {
        component: GeminiConfiguration,
        getProps: ({
            form,
            handleParameter
        }) => ({
            parameters: form.geminiParameters,
            setParameters: handleParameter
        })
    },
    Cerebras: {
        component: CerebrasConfiguration,
        getProps: ({
            form,
            handleParameter
        }) => ({
            parametersCerebras: form.cerebrasParameters,
            setParametersCerebras: handleParameter
        })
    },
    Mistral: {
        component: MistralConfiguration,
        getProps: ({
            form,
            handleParameter
        }) => ({
            parameters: form.mistralParameters,
            setParameters: handleParameter
        })
    },
    Novita: {
        component: NovitaConfiguration,
        getProps: ({
            form,
            handleParameter
        }) => ({
            parameters: form.novitaParameters,
            setParameters: handleParameter
        })
    }
};
